import { isNonNaNNumber, LinkType, toEsp } from '@iotv/iotv-v3-types';
import { dateTimeNow } from '../../cellFormatters/valueFormatters';
import { getCoordinateDistance } from './helperFns';
export const getFlatLCDDeviceMessage = (deviceMessage) => {
    const { nwID, nasSourceIp, app_id, adr, bw, codeRate, deviceName, dr, sf, frequency, linkType, port, deviceType, fCnt, fCntInc, bearings, deviceEui, timestamp, power, primaryGatewayRXData, nmMonitoringAttributes, payloadStr, resolvedCustomer, resolvedGroup, resolvedDevice, resolvedEntity, resolvedProperty, deviceLocation, consumedAirtimeSecs, } = deviceMessage;
    const { rssi, snr, channel, gatewayEui, gatewayLocation, gatewayIdName, esp } = primaryGatewayRXData ?? {};
    const { position, battery, batteryCharging, reboot, downlinkAck, batteryErr, linkCheckErr, temperature, humidity } = nmMonitoringAttributes ?? {};
    const { name: customerName, id: customerId } = resolvedCustomer ?? {};
    const { name: groupName, id: groupId } = resolvedGroup ?? {};
    const { name: propertyName, id: propertyId } = resolvedProperty ?? {};
    const { name: entityName, id: entityId, type: entityType } = resolvedEntity ?? {};
    const { dailyFCntSkip: devFCntJumpDaily, dailyMessageCount: devMessageCntDaily, yesterdaysFCntJumpTotal: ystrdayFCntJump, yesterdaysMessageCntTotal: ystrdayMsgCntJump, } = resolvedDevice ?? {};
    const size = payloadStr?.length;
    let distance = undefined;
    const deviceLat = deviceLocation?.lat || position?.lat;
    const deviceLng = deviceLocation?.lng || position?.lng;
    if (gatewayLocation?.lat && gatewayLocation?.lng && deviceLat && deviceLng) {
        distance = getCoordinateDistance(gatewayLocation?.lat, deviceLat, gatewayLocation?.lng, deviceLng);
    }
    let espCalculated = undefined;
    if (esp === undefined || !isNonNaNNumber(esp)) {
        espCalculated = toEsp(rssi, snr);
    }
    const flatMessage = {
        id: `${deviceEui}_${timestamp}`,
        timestamp,
        timestampConverted: timestamp + '',
        propertyName,
        customerName,
        groupName,
        nwID,
        nasSourceIp,
        app_id,
        gatewayEui,
        gatewayLat: gatewayLocation?.lat,
        gatewayLng: gatewayLocation?.lng,
        gatewayDOP: undefined,
        deviceEui,
        entityName,
        devState: undefined,
        deviceLat,
        deviceLng,
        devDoP: position?.DOP,
        battery,
        batteryV: battery,
        batteryCharging,
        temperature,
        humidity,
        distance,
        esp: esp ?? espCalculated,
        rssi,
        snr,
        sf,
        power,
        port,
        frequency,
        channel,
        linkType: linkType ?? LinkType.UP,
        fCnt,
        fCntInc,
        GtD: bearings?.gatewayToDeviceBearing,
        DBear: bearings?.deviceBearing,
        DtG: bearings?.deviceToGatewayAngle,
        devFCntJumpDaily,
        devMessageCntDaily,
        ystrdayFCntJump,
        ystrdayMsgCntJump,
        size,
        consumedAirtimeSecs,
        payloadStr: payloadStr,
        adr,
        bw,
        codeRate,
        deviceName,
        dr,
        deviceType,
        gatewayIdName,
        batteryErr,
        downlinkAck,
        linkCheckErr,
        reboot,
        // Hyperlinks
        deviceSk: `Device:${deviceEui}`,
        gatewaySk: `Gateway:${gatewayEui}`,
        propertySk: `Property:${propertyId}`,
        customerSk: `Customer:${customerId}`,
        groupSk: `Group:${groupId}`,
        entitySk: entityType && entityId ? `${entityType}:${entityId}` : undefined,
    };
    return flatMessage;
};
export const getFlatLCDDeviceMessageForExport = (deviceMessage) => {
    const { nwID, nasSourceIp, app_id, adr, bw, codeRate, deviceName, dr, sf, frequency, linkType, port, deviceType, fCnt, fCntInc, bearings, consumedAirtimeSecs, deviceEui, timestamp, power, primaryGatewayRXData, nmMonitoringAttributes, payloadStr, resolvedCustomer, resolvedGroup, resolvedDevice, resolvedEntity, resolvedProperty, deviceLocation, } = deviceMessage;
    const { rssi, snr, channel, gatewayEui, gatewayLocation, gatewayIdName, esp } = primaryGatewayRXData ?? {};
    const { position, battery, batteryCharging, reboot, downlinkAck, batteryErr, linkCheckErr, temperature, humidity } = nmMonitoringAttributes ?? {};
    const { name: customerName, id: customerId } = resolvedCustomer ?? {};
    const { name: groupName, id: groupId } = resolvedGroup ?? {};
    const { name: propertyName, id: propertyId } = resolvedProperty ?? {};
    const { name: entityName, id: entityId, type: entityType } = resolvedEntity ?? {};
    const { dailyFCntSkip: devFCntJumpDaily, dailyMessageCount: devMessageCntDaily, yesterdaysFCntJumpTotal: ystrdayFCntJump, yesterdaysMessageCntTotal: ystrdayMsgCntJump, } = resolvedDevice ?? {};
    const size = payloadStr?.length;
    let distance = undefined;
    const deviceLat = deviceLocation?.lat || position?.lat;
    const deviceLng = deviceLocation?.lng || position?.lng;
    if (gatewayLocation?.lat && gatewayLocation?.lng && deviceLat && deviceLng) {
        distance = getCoordinateDistance(gatewayLocation?.lat, deviceLat, gatewayLocation?.lng, deviceLng);
    }
    let espCalculated = undefined;
    if (esp === undefined || !isNonNaNNumber(esp)) {
        espCalculated = toEsp(rssi, snr);
    }
    const flatMessage = {
        id: `${deviceEui}_${timestamp}`,
        timestamp: timestamp,
        timestampConverted: dateTimeNow(timestamp, undefined, undefined, undefined),
        propertyName,
        customerName,
        groupName,
        nwID,
        nasSourceIp,
        app_id,
        gatewayEui,
        gatewayLat: gatewayLocation?.lat,
        gatewayLng: gatewayLocation?.lng,
        gatewayDOP: undefined,
        deviceEui,
        entityName,
        devState: undefined,
        deviceLat,
        deviceLng,
        devDoP: position?.DOP,
        battery,
        batteryV: battery,
        batteryCharging,
        temperature,
        humidity,
        distance,
        esp: esp ?? espCalculated,
        rssi,
        snr,
        sf,
        power,
        port,
        frequency,
        channel,
        linkType: linkType ?? LinkType.UP,
        fCnt,
        fCntInc,
        devFCntJumpDaily,
        devMessageCntDaily,
        ystrdayFCntJump,
        ystrdayMsgCntJump,
        size,
        consumedAirtimeSecs,
        payloadStr: '0x' + payloadStr,
        adr,
        bw,
        codeRate,
        deviceName,
        dr,
        deviceType,
        gatewayIdName,
        batteryErr,
        downlinkAck,
        linkCheckErr,
        reboot,
        // Hyperlinks
        deviceSk: `Device:${deviceEui}`,
        gatewaySk: `Gateway:${gatewayEui}`,
        propertySk: `Property:${propertyId}`,
        customerSk: `Customer:${customerId}`,
        groupSk: `Group:${groupId}`,
        entitySk: `${entityType}:${entityId}`,
        GtD: bearings?.gatewayToDeviceBearing,
        DBear: bearings?.deviceBearing,
        DtG: bearings?.deviceToGatewayAngle,
    };
    return flatMessage;
};
